module.exports = __webpack_public_path__ + "img/clock.90e3864b.svg";